// Écran « Domaines » du shell mobile Life — DA V3 validée : recherche,
// favoris, grille des domaines avec liseré coloré (couleurs SmartFeed),
// conseillers IA et outils. Chaque vignette mène vers la page existante.
// Réf. : DEV/mockup_mobile_navigation_v3.html
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const FAVORITES = [
  { key: 'finances', label: ['domains.finances', 'Finances'], icon: '💰', color: 'var(--lm-finance)', path: '/Dashboard', sub: ['domains.financesSub', 'Comptes · budget · opérations'] },
  { key: 'temps', label: ['domains.time', 'Temps'], icon: '⏱️', color: 'var(--lm-temps)', path: '/syntheseTemps', sub: ['domains.timeSub', 'Agenda · équilibre de vie'] },
]

const DOMAINS = [
  { key: 'patrimoine', label: ['domains.wealth', 'Patrimoine'], icon: '🏛️', color: '#22c55e', path: '/MonPatrimoine', sub: ['domains.wealthSub', 'Vue globale · projections'] },
  { key: 'pro', label: ['domains.pro', 'Pro'], icon: '💼', color: 'var(--lm-pro)', path: '/professionnelle', sub: ['domains.proSub', 'Carrière · opportunités'] },
  { key: 'domicile', label: ['domains.home', 'Domicile'], icon: '🏡', color: 'var(--lm-domicile)', path: '/domicile/monimmobilier', sub: ['domains.homeSub', 'Immobilier · véhicules · entretien'] },
  { key: 'social', label: ['domains.social', 'Social'], icon: '👥', color: 'var(--lm-social)', path: '/social-dashboard', sub: ['domains.socialSub', 'Contacts · relations'] },
  { key: 'sante', label: ['domains.health', 'Santé'], icon: '❤️', color: 'var(--lm-sante)', path: '/sante', sub: ['domains.healthSub', 'Copilote santé'] },
  { key: 'invest', label: ['domains.investments', 'Investissements'], icon: '📈', color: 'var(--lm-indigo)', path: '/investments', sub: ['domains.investmentsSub', 'Portefeuille · marchés'] },
  { key: 'perso', label: ['domains.personal', 'Personnel'], icon: '🌱', color: 'var(--lm-perso)', path: '/BucketList', sub: ['domains.personalSub', 'Bucket list · recettes'] },
  { key: 'objectifs', label: ['domains.goals', 'Objectifs'], icon: '🎯', color: '#a3e635', path: '/mesobjectifs', sub: ['domains.goalsSub', 'Mes objectifs de vie'] },
  { key: 'roadmap', label: ['domains.roadmap', 'Roadmap'], icon: '🗺️', color: 'var(--lm-violet)', path: '/roadmap', sub: ['domains.roadmapSub', 'Mon cap long terme'] },
]

const ADVISORS = [
  { label: 'Conseiller patrimonial', path: '/conseiller-patrimonial', icon: '🏛️' },
  { label: 'Conseiller temps', path: '/conseiller-temps', icon: '⏱️' },
  { label: 'Conseiller pro / formation', path: '/conseiller-pro', icon: '💼' },
  { label: 'Conseiller social', path: '/conseiller-social', icon: '👥' },
  { label: 'Conseiller écologie', path: '/conseiller-ecologie', icon: '🌍' },
  { label: 'Conseiller organisation', path: '/conseiller-organisation', icon: '🗂️' },
]

const TOOLS = [
  { key: 'documents', label: ['domains.documents', 'Documents'], icon: '📄', color: '#94a3b8', path: '/documents', sub: ['domains.documentsSub', 'Coffre-fort'] },
  { key: 'inbox', label: ['domains.inbox', 'Inbox'], icon: '📥', color: '#94a3b8', path: '/inbox', sub: ['domains.inboxSub', 'Notifications · à traiter'] },
  { key: 'resume', label: ['domains.lifeResume', 'Life Résumé'], icon: '📊', color: 'var(--lm-indigo)', path: '/life-resume', sub: ['domains.lifeResumeSub', 'Rapport global IA'] },
]

const Tile = ({ item, fav, onClick, t }) => (
  <div className="lm-dom" style={{ '--c': item.color }} onClick={onClick}>
    {fav && <span className="lm-fav">★</span>}
    <div
      className="lm-ic"
      style={{ background: `color-mix(in srgb, ${item.color} 18%, transparent)` }}
    >
      {item.icon}
    </div>
    <div className="lm-t">{t(item.label[0], item.label[1])}</div>
    <div className="lm-s">{t(item.sub[0], item.sub[1])}</div>
  </div>
)

const MobileDomains = () => {
  const { t } = useTranslation(['layout', 'common'])
  const navigate = useNavigate()
  const [query, setQuery] = React.useState('')
  const [advisorsOpen, setAdvisorsOpen] = React.useState(false)

  const go = (path) => {
    navigate(path)
    window.scrollTo(0, 0)
  }

  const submitSearch = () => {
    const q = query.trim()
    if (q) navigate(`/search/0/${q}`)
  }

  return (
    <div className="lm-page">
      <div className="lm-search-row" style={{ marginTop: 0 }}>
        <svg viewBox="0 0 24 24">
          <circle cx="11" cy="11" r="7" />
          <path d="M20 20l-3.5-3.5" />
        </svg>
        <input
          value={query}
          placeholder={t('navbar.searchPlaceholder', 'Rechercher partout dans Life…')}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && submitSearch()}
        />
      </div>

      <div className="lm-stitre">★ {t('domains.favorites', 'Favoris')}</div>
      <div className="lm-grille">
        {FAVORITES.map((d) => (
          <Tile key={d.key} item={d} fav t={t} onClick={() => go(d.path)} />
        ))}
      </div>

      <div className="lm-stitre">{t('domains.all', 'Tous les domaines')}</div>
      <div className="lm-grille">
        {DOMAINS.map((d) => (
          <Tile key={d.key} item={d} t={t} onClick={() => go(d.path)} />
        ))}
        <div
          className="lm-dom"
          style={{ '--c': 'var(--lm-violet)' }}
          onClick={() => setAdvisorsOpen((v) => !v)}
        >
          <div
            className="lm-ic"
            style={{ background: 'color-mix(in srgb, #764ba2 18%, transparent)' }}
          >
            🧭
          </div>
          <div className="lm-t">{t('domains.advisors', 'Conseillers IA')}</div>
          <div className="lm-s">
            {advisorsOpen
              ? t('domains.advisorsClose', 'Replier la liste')
              : t('domains.advisorsSub', `${ADVISORS.length} conseillers`)}
          </div>
        </div>
      </div>

      {advisorsOpen && (
        <>
          <div className="lm-stitre">🧭 {t('domains.advisors', 'Conseillers IA')}</div>
          {ADVISORS.map((a) => (
            <div key={a.path} className="lm-prow" onClick={() => go(a.path)}>
              <div className="lm-pi">{a.icon}</div>
              <div className="lm-fl">{a.label}</div>
              <div className="lm-ch">›</div>
            </div>
          ))}
        </>
      )}

      <div className="lm-stitre">{t('domains.tools', 'Outils')}</div>
      <div className="lm-grille">
        {TOOLS.map((d) => (
          <Tile key={d.key} item={d} t={t} onClick={() => go(d.path)} />
        ))}
      </div>
    </div>
  )
}

export default MobileDomains
